import fetch from 'isomorphic-fetch'
import config from '../config'

export default {
  me (token) {
    return this._request('/me', token)
  },

  users (token) {
    return this._request('/users', token)
  },

  countUsers (token) {
    return this._request('/users/count', token)
  },

  customers (token) {
    return this._request('/customers', token)
  },

  projects (token) {
    return this._request('/projects', token)
  },

  segments (token, projectId) {
    return this._request(`/segment?project=${projectId}`, token)
  },

  _request (path, token, method = 'GET', data = null) {
    const options = {
      method,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      }
    }

    if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
      options.mode = 'cors'
      options.body = JSON.stringify(data || {})
      options.headers['Content-Type'] = 'application/json'
    }

    return fetch(`${config.endpoint}${path}`, options).then(response => {
      const status = parseInt(response.status, 10)

      if (status !== 200 && status !== 204) {
        const err = new Error(`Got non-200 response code (${status}): ${response.responseText || ''}`)
        err.code = status
        err.response = response
        throw err
      }

      return response.json()
    })
  }
}



// WEBPACK FOOTER //
// ./lib/api.js